import * as React from 'react';
import { Segment, Container, Grid, Image } from 'semantic-ui-react';

const NotFoundImageSegment = () =>
  <Segment vertical style={{ padding: '4em 0em 4em 0em' }}>
    <Container>
      <Grid container stackable>
        <Grid.Row centered>
          <Image src="/images/404.gif" />
        </Grid.Row>        
      </Grid>
    </Container>
  </Segment>

export default NotFoundImageSegment



// WEBPACK FOOTER //
// ./src/page-not-found/NotFoundImageSegment.tsx